export default __webpack_public_path__ + "static/4-9f5fb8100ea6eaefbee3fa7286b693d4.jpeg";